import { ThemeInterface } from 'wix-style-react-tpa/dist/types/ThemeProvider/types';
import {
  PlusLarge,
  PlusXSmall,
} from '@wix/wix-ui-icons-common/on-stage/system';
import { Plus, PlusSmall } from '@wix/wix-ui-icons-common/on-stage';

export const theme = (className?: string): ThemeInterface => ({
  className,
  icons: {
    AddItemButton: {
      tiny: PlusXSmall,
      small: PlusSmall,
      medium: Plus,
      large: PlusLarge,
      image: null,
    },
  },
});
